import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Half } from '../../../images/send-coupon.svg';

export const SendCouponIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={Half} />
);

export default SendCouponIcon;
